import { render, staticRenderFns } from "./OsobaGrupeStatusa.vue?vue&type=template&id=45f1e8b0&scoped=true&"
import script from "./OsobaGrupeStatusa.vue?vue&type=script&lang=js&"
export * from "./OsobaGrupeStatusa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f1e8b0",
  null
  
)

export default component.exports